export function normalizeUsPhoneDigits(value: string) {
  const digits = value.replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) {
    return digits.slice(1);
  }
  return digits.slice(0, 10);
}

export function formatUsPhone(value: string) {
  const digits = normalizeUsPhoneDigits(value);
  if (!digits) return "";
  if (digits.length < 4) return `(${digits}`;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function formatUsPhoneDisplay(value: string | undefined | null) {
  if (!value) return "-";
  const formatted = formatUsPhone(value);
  return formatted || "-";
}
